module.exports = __webpack_public_path__ + "static/media/ico_pass.2279f1a3.png";